import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectSaidaisekisairyou from 'components/site/select_saidaisekisairyou'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectSaidaisekisairyouStart: state.searchFormCondition.selectSaidaisekisairyouStart,
  selectSaidaisekisairyouFinish: state.searchFormCondition.selectSaidaisekisairyouFinish,
})

const SaidaisekisairyouContainer = connect(mapStateToProps, mapDispatchToProps)(SelectSaidaisekisairyou)

export default SaidaisekisairyouContainer
